<template>
    <div class="page login">
        <el-row>
            <el-col class="loginBoxImage" :lg="14" :xl="14">
                <div class="welcomeLogin">
                    <div class="greet-SKF-ability-box">
                        <div class="greet">欢迎登录</div>
                        <div class="SKF">
                            <!-- 这是个背景图不能删 -->
                            <span></span>
                            <span>斯凯孚(济南)WMS系统</span>
                        </div>
                        <div class="ability">
                            <span>专业</span>
                            <span>智能</span>
                            <span>科技</span>
                            <span>放心托付</span>
                        </div>
                    </div>
                </div>
                <div class="loginInput">
                    <div class="userLogin-text">用户登录</div>
                    <div class="login-input">
                        <el-image class="login-input-image" :src="require('@/assets/icon/账号.png')"></el-image>
                        <el-input :style="userNameStyle" placeholder="请输入账号" v-on:blur="listenBtn" v-model="userName" type="text" @keyup.enter.native="login"></el-input>
                    </div>
                    <div class="login-input">
                        <el-image class="login-input-image" :src="require('@/assets/icon/密码.png')"></el-image>
                        <el-input placeholder="请输入密码" type="password" v-model="passWord" @keyup.enter.native="login"></el-input>
                    </div>
                    <div class="login-input" v-if="urlPort==''">
                        <el-image class="login-input-image" :src="require('@/assets/icon/账号.png')"></el-image>
                        <el-input style="font-size: 16px;width: 160px;padding: 0;" placeholder="请输入手机号码" v-model="phone" type="text"></el-input>
                        <el-button class="login-input-btn" size="small" v-bind:class="{gray:wait_timer>0}" @click="getVerificationCode()">
                            <span class="num_green" v-show="showNum" v-bind:class="{num:wait_timer>0}">{{this.wait_timer + "s "}}</span>
                            <span class="span_number" v-bind:class="{gray_span:wait_timer>0}">{{ getCodeText() }}</span>
                        </el-button>
                    </div>
                    <div class="login-input" v-if="urlPort==''">
                        <el-image class="login-input-image" :src="require('@/assets/icon/账号.png')"></el-image>
                        <el-input style="font-size: 16px;padding: 0;" placeholder="请输入验证码" v-model="verificationCodeNew" type="text" @keyup.enter.native="login"></el-input>
                    </div>
                    <el-button class="btn" @click="login">登录</el-button>
                </div>
            </el-col>
        </el-row>
    </div>
</template>

<script>
    export default {
        name: "Login",
        props: {},
        data() {
            return {
                fcCodeList:[],
                userName: "",
                passWord: "",
                fcCode: "",
                logContent: "", //操作日志-内容
                logRemarks: "", //操作日志-备注
                urlPort: "",
                phone: "",
                verificationCode: "", //手机返回的验证码
                verificationCodeNew: "", //填写的验证码
                wait_timer: false,
                showNum: false,
            };
        },
        mounted() {},
        methods: {
            listenBtn(){
                // if(this.userName != ''){
                    // this.getFcCode();
                // }
            },
            getFcCode(){
                this.$http
                        .request({
                            url: "/api/user/getUser",
                            method: "GET",
                            params: {
                                account: this.userName,
                            },
                        })
                        .then((resp) => {
                            this.fcCode = resp.data.fcCode || '';
                            this.phone = resp.data.userPhone || '';
                        });
            },
            getFactoryAll(){
                this.$http
                        .request({
                            url: "/api/factory/getFactoryAll",
                            method: "GET",
                        })
                        .then((resp) => {
                            this.fcCodeList = resp.data.list;
                            
                        });
            },
            getCodeText: function() {
                if (this.wait_timer > 0) {
                    return "已发送";
                }
                if (this.wait_timer === 0) {
                    this.showNum = false;
                    return "重新发送";
                }
                if (this.wait_timer === false) {
                    return "发送验证码";
                }
            },
            getVerificationCode() {
                if (this.wait_timer > 0) {
                    return 
                }
                if (!this.phone) {
                    this.$message({
                        message: "没有输入手机号码!",
                        type: "error",
                    });
                    return
                }
                if (this.phone.length != 11) {
                    this.$message({
                        message: "请输入正确的手机号码!",
                        type: "error",
                    });
                    return
                }
                this.showNum = true;
                this.wait_timer = 300;
                var that = this;
                var timer_interval = setInterval(function() {
                    if (that.wait_timer > 0) {
                        that.wait_timer--;
                    } else {
                        clearInterval(timer_interval);
                    }
                }, 1000);
                that.$http
                    .request({
                        url: "/api/user/getMessage",
                        method: "GET",
                        params: {
                            phone: that.phone
                        }
                    })
                    .then((resp) => {
                        if(resp.status == 100) {
                            that.verificationCode = resp.data
                        } else {
                            that.$message({
                                message: resp.message,
                                type: "error",
                            });
                        }
                    }).catch((error) => {
                        that.$message({
                            message: "获取验证码失败",
                            type: "error",
                        });
                    });
            },
            login() {
                if (this.userName && this.passWord) {
                    if (this.urlPort!=null && this.urlPort=='') {
                        if (this.wait_timer === 0) {
                            this.$message({
                                message: "验证码已过期，请重新获取!",
                                type: "error",
                            });
                            return
                        }
                        if (this.wait_timer === false) {
                            this.$message({
                                message: "请获取手机验证码!",
                                type: "error",
                            });
                            return
                        }
                        if (!this.verificationCode) {
                            this.$message({
                                message: "请获取手机验证码进行验证!",
                                type: "error",
                            });
                            return
                        }
                        if (!this.verificationCodeNew) {
                            this.$message({
                                message: "请填写手机验证码!",
                                type: "error",
                            });
                            return
                        }
                        if(this.verificationCode != this.verificationCodeNew) {
                            this.$message({
                                message: "验证码不一致，请确认!",
                                type: "error",
                            });
                            return
                        }
                    }

                    this.$http
                        .request({
                            url: "/api/user/user_login",
                            method: "POST",
                            showLoading: true,
                            params: {
                                account: this.userName,
                                password: this.passWord,
                            },
                        })
                        .then((resp) => {
                            if (resp.status == 100) {
                                if (typeof resp.data.authorities == "undefined") {
                                    this.$message({
                                        message: "用户未分配角色!",
                                        type: "error",
                                    });
                                    return;
                                }
                                // console.log(resp.data);
                                localStorage.setItem("token", resp.data.token || "");
                                localStorage.setItem("user", resp.data.userAccount || "");
                                localStorage.setItem("password", resp.data.userPasswd || "");
                                localStorage.setItem("id", resp.data.userId || "");
                                localStorage.setItem("empNumber", resp.data.empNumber || "");
                                localStorage.setItem("userName", resp.data.userName || "");
                                localStorage.setItem("fcCode", resp.data.fcCode || "");
                                localStorage.setItem("whCode", resp.data.whCode || "");
                                localStorage.setItem("roleCode", resp.data.authorities.roleCode || "");
                                localStorage.setItem("allAuths",JSON.stringify(resp.data.authorities.auths || [])); //权限
                                this.$permission.setAuths(resp.data.authorities.auths || []);
                                this.jump("/home");
                                // this.$router.push({
                                //     name: 'home'
                                // })
                                //tabs 缓存
                                this.$store.commit('clearTags')
                                this.$message({
                                    message: "登录成功!",
                                    type: "success",
                                });
                                this.logRemarks = "login：登录成功";
                            } else {
                                this.passWord = "";
                                this.$message.error(resp.message);
                                this.logRemarks = "login：登录失败，" + resp.message;
                            }
                            this.logContent = "后台用户登录：账号为：" + this.userName;
                            this.systemLog();
                        });
                } else {
                    this.$message.error("账号密码不能为空!");
                }
            },
            /**
             * 操作日志
             */
            systemLog() {
                let objData = {
                    logType: "back-login",
                    logContent: this.logRemarks || null,
                    //logRemarks: this.logRemarks || null,
                    logUser: localStorage.getItem("user") || "",
                };
                this.$http
                    .request({
                        url: "api/log/insert",
                        method: "POST",
                        data: objData,
                    })
                     .then((resp) => {
                        this.logContent = "";
                        this.logRemarks = "";
                        if (resp.status == 100) {}
                    })
                    .catch((error) => {});
            },
        },
        created(){
            this.getFactoryAll()
            
            this.urlPort = window.location.port
        },
        computed: {
            userNameStyle() {
                if (this.userName) {
                    return {
                        "font-size": "18px",
                        padding: "0",
                    };
                } else {
                    return {
                        "font-size": "16px",
                        padding: "0",
                    };
                }
            },
        },
    };
</script>

<style scoped lang="scss">
    .loginBoxImage {
        display: block;
        content: "";
        clear: both;
    }

    .login {
        background-image: url("../assets/bg-1.png");
        background-size: 100% 100%;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .loginBoxImage {
        min-width: 1000px;
        min-height: 400px;
        background-image: url("../assets/bg-2.png");
        background-size: 100% 100%;

        .welcomeLogin {
            width: 60%;
            min-height: 400px;
            color: white;
            font-size: 1.5rem;
            text-align: left;
            display: flex;
            align-items: center;

            .greet-SKF-ability-box {
                width: 80%;
                height: 100%;
                margin-left: 20%;

                .greet {
                    width: 5rem;
                    white-space: nowrap;
                    display: inline-block;
                    font-size: 2rem;
                    padding-bottom: 15px;
                    margin-bottom: 25px;
                    border-bottom: 3px solid white;
                }

                .SKF {
                    span:nth-child(1) {
                        width: 4rem;
                        height: 2.5rem;
                        display: inline-block;
                        background-image: url("../assets/logo.png");
                        background-size: 100% 100%;
                        vertical-align: middle;
                        margin-right: 5px;
                        margin-bottom: 20px;
                    }

                    span:nth-child(2) {
                        font-weight: bold;
                        letter-spacing: 3px;
                        vertical-align: middle;
                    }
                }

                .ability {
                    span {
                        margin-right: 20px;
                    }
                }
            }
        }

        .loginInput {
            width: 35%;
            min-height: 460px;
            position: absolute;
            top: -30px;
            right: 5%;
            border-radius: 20px;
            background-image: url("../assets/矩形3.png");
            background-size: 100% 100%;
            letter-spacing: 3px;
            box-sizing: border-box;
            padding-top: 40px;
            opacity: 0.9;

            .userLogin-text {
                color: #1f6cec;
                font-size: 1.5rem;
            }

            .login-input {
                margin: 0 auto;
                color: #818c9a;
                width: 80%;
                height: 5vh;
                margin-top: 3vh;
                box-shadow: -0.12px 1px 8px 0px rgba(82, 172, 178, 0.2);
                border-radius: 20px;
                display: flex;
                align-items: center;
                overflow: hidden;
                background-color: white;

                .login-input-image {
                    box-sizing: border-box;
                    width: 20px;
                    margin-left: 10px;
                    padding: 1px;
                }

                .login-input-btn {
                    border: 0px;
                }
            }
        }

        .btn {
            color: white;
            width: 80%;
            border-radius: 20px;
            background-color: #55c0fb;
            background: linear-gradient(to right, #55c0fb, #2271ed);
            margin-top: 2vh;
        }
    }
</style>